import CrudPage, { fmtMoney } from "../components/CrudPage";
import { StatusBadge } from "../components/Shared";
import { Money } from "@phosphor-icons/react";

const CUR_OPTS = [
  { value: "TRY", label: "₺ TRY" }, { value: "USD", label: "$ USD" }, { value: "EUR", label: "€ EUR" }, { value: "GBP", label: "£ GBP" },
];

export default function Checks() {
  return (
    <CrudPage
      title="Çekler"
      subtitle="Alınan ve verilen çekler"
      endpoint="checks"
      exportEntity="checks"
      emptyIcon={Money}
      testidPrefix="cek"
      fields={[
        { name: "check_no", label: "Çek No" },
        { name: "type", label: "Tür", type: "select", default: "received", options: [{ value: "received", label: "Alınan" }, { value: "issued", label: "Verilen" }] },
        { name: "bank_name", label: "Banka" },
        { name: "amount", label: "Tutar", type: "number" },
        { name: "currency", label: "Para Birimi", type: "select", default: "TRY", options: CUR_OPTS },
        { name: "due_date", label: "Vade Tarihi", type: "date" },
        { name: "status", label: "Durum", type: "select", default: "pending", options: [{ value: "pending", label: "Bekliyor" }, { value: "cleared", label: "Tahsil Edildi" }, { value: "bounced", label: "Karşılıksız" }] },
      ]}
      columns={[
        { key: "check_no", label: "Çek No", render: (i) => `#${i.check_no}` },
        { key: "type", label: "Tür", render: (i) => (
          <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${i.type === "received" ? "bg-emerald-500/15 text-emerald-400" : "bg-amber-500/15 text-amber-400"}`}>
            {i.type === "received" ? "Alınan" : "Verilen"}
          </span>
        ) },
        { key: "bank_name", label: "Banka" },
        { key: "due_date", label: "Vade" },
        { key: "status", label: "Durum", render: (i) => <StatusBadge status={i.status} /> },
        { key: "amount", label: "Tutar", align: "right", render: (i) => fmtMoney(i.amount, i.currency) },
      ]}
    />
  );
}
